export default __webpack_public_path__ + "static/media/capacitación.4f07df0b.png";